import React from "react";
import { toast } from "sonner";
import { hapticFeedback } from "@telegram-apps/sdk-react";

type VibrationType = "success" | "warning" | "error";
type ToastOptions = {
    description?: string;
    icon?: React.JSX.Element;
    className?: string;
}

const showCustomToast = (message: string | React.JSX.Element, type: VibrationType, options?: ToastOptions) => {
  toast[type](message, options);

  if (hapticFeedback.notificationOccurred.isAvailable()) {
    hapticFeedback.notificationOccurred(type);
  }
};

export default showCustomToast;